import { createFileRoute } from '@tanstack/react-router';
import { EmployeeReimbursementModule } from '@/modules/employee-reimbursement';

export const Route = createFileRoute('/(dashboard)/_dashboard/reimbursement')({
  component: EmployeeReimbursementModule,
});
